$(function () {

    // open cart
    $("body").on("click", ".cart-link", function () {
        refreshCart();
    });
   
    $("body").on("click", ".cart-heading .close-cart", function () {
        $(".cart-summary-overlay").css("display", "none"); 
        $(".cart-summary-overlay").removeClass("side-cart-open"); 
        $("body").css("overflow", "auto"); 
        $("#sidebar-cart-overlay").css({"pointer-events": "none", "opacity": "0"});
    });
    // end open cart


    // Out Of box click
    $(document).mouseup(function(e) {
        var container = $("#sidebar-cart");
        var giftCartClose = $(".giftcart_close svg");
        if (!container.is(e.target) && container.has(e.target).length === 0 && !giftCartClose.is(e.target))
        {
            container.removeClass("side-cart-open");
            $("body").css("overflow", "auto"); 
            $("#sidebar-cart-overlay").css({"pointer-events": "none", "opacity": "0"});
        }
    });
    // Out Of box click end

    function updateQuantity(quantity,id){
        $.ajax({
            url: `${theme.routes.cart_url}/change.js`,
            data: { quantity, id },
            dataType: 'json',
            success: function(data) {
                jQuery.getJSON('/cart.js', function(data) {
                    refreshCart(data);
                });
            }
        });
    }
 
  // let data_replace = $(htmlData).find('#data').html();
  // $('#data').html(data_replace);
  // $(".cart-summary-overlay").addClass("side-cart-open");
  // $('#sidebar-cart-overlay').css({'opacity':"1","pointer-events":"none"})
  // $('body').css('overflow',"hidden");
  // $.get("/browsing_context_suggestions.json", function(data) {
  //     let userCountry = data.detected_values.country.handle;
  //   if(userCountry == 'NL' || userCountry== 'LU'|| userCountry == 'BE'){
  //     $('.gk-sidebar-header').show();
  //   }else{
  //     $('.gk-sidebar-body').css('padding-top','15px');
  //   }
  // });
   window.refreshCart =  function() {
        $.ajax({
            url: `${theme.routes.cart_url}?view=sidebar-cart`,
            dataType: 'HTML',
            method: "GET",
            success: function (htmlData) {
               
              var data_replace_data = $(htmlData).find('#data');
              var classes = data_replace_data[0].querySelector("#sidebar-cart").getAttribute("class");
              var data_replace = $(htmlData).find('#sidebar-cart');
              $('#sidebar-cart').html(data_replace.html());
              console.log("classes replaced");
              $('#sidebar-cart').attr("class", classes);
              $('#sidebar-cart').addClass("side-cart-open");
              console.log($('#sidebar-cart').attr("class"));
              $(".cart-summary-overlay").addClass("side-cart-open");
            
              $('#sidebar-cart-overlay').css({'opacity':"1","pointer-events":"none"});
              $('body').css('overflow',"hidden");
              $.get("/browsing_context_suggestions.json", function(data) {
                  let userCountry = data.detected_values.country.handle;
                if(userCountry == 'NL' || userCountry== 'LU'|| userCountry == 'BE'){
                  $('.gk-sidebar-header').show();
                  $("html").attr("data-country", userCountry);
                }else{
                  $('.gk-sidebar-body').css('padding-top','15px');
                }
              });
              //ux improvement cro specific
              if(sessionStorage.getItem('hideCartUpsell')){
                $('.gk-sidebar-you-may-link.mobile-view').remove()
              }
              if(typeof window.recomHandleIntersection == 'function') window.recomHandleIntersection()
            }
        });
    }
    

    $(document).on('click','.add_to_cart',function(){
        var id = $(this).attr('data-id');
        var quantity = 1;
        $.ajax({
            url: `${theme.routes.cart_url}/add.js`,
            data: { quantity, id },
            dataType: 'json',
            success: function(data) {
                jQuery.getJSON('/cart.js', function(data) {
                    refreshCart(data);
                });
            }
        })
    })
    // Increment/decrement counter
    $(document).on('click','.js-quantity-minus',function(){
        var value = $(this).next().val();
        if(value > 1) {
            value--;
            $(this).next().val(value);
        } 
        let quantity = $(this).parents('.quantity').find('.js-quantity-input').val();
        let id = $(this).parents('.quantity').attr('data-id');
        updateQuantity(quantity,id);
    });
    $(document).on('click','.js-quantity-plus',function(){
        var value = $(this).prev().val();
        if(value) {
            value++;
            $(this).prev().val(value);
        }

        let quantity = $(this).parents('.quantity').find('.js-quantity-input').val();
        let id = $(this).parents('.quantity').attr('data-id');
        updateQuantity(quantity,id);
    });
    // end Increment/decrement counter

    $(document).on('click','.cart-remove-product',function(){
        let id = $(this).parents('.cart-desc-col').find('.quantity').attr('data-id');
        updateQuantity(0,id);
    });

   // complementry
    $(document).on('change','.complementary-products [data-single-option-selector]',function(){
        var id = $(this).val();
        console.log($(this).find('option:selected').attr('data-soldout'))
        $(this).find('option:selected').attr('data-soldout') != undefined ? $(this).parents('li.product').find('.complementary-atc.add_to_cart').attr('disabled', 'disabled') : $(this).parents('li.product').find('.complementary-atc.add_to_cart').removeAttr('disabled')
        $(this).parents('li.product').find('.complementary-atc.add_to_cart').attr('data-id', id)
    })

  $(document).on(
        "change",
        ".complementary-products li.product .styled-select>select",
        function () {
          var selectedOptions = [];
          selectedOptions.push($(this).val());
          var productData = JSON.parse(
            $(this)
              .parents("li.product")
              .find('[type="application/json"]')
              .html() || "[]"
          );
          $(this)
            .parents(".selector-wrapper")
            .siblings(".selector-wrapper")
            .find("select")
            .each(function () {
              selectedOptions.push($(this).val());
            });
          var variant = false;
    
          for (var i = 0; i < productData.variants.length; i++) {
            var v = productData.variants[i];
            var matchCount = 0;
    
            for (var j = 0; j < selectedOptions.length; j++) {
              if (v.options[j] == selectedOptions[j]) {
                matchCount++;
              }
            }
    
            if (matchCount == selectedOptions.length) {
              variant = v;
              break;
            }
          }
          if (variant) {
            var isSoldOut = variant.available;
            $(this)
              .parents("li.product")
              .find(".complementary-atc.add_to_cart")
              .attr("data-id", variant.id);
            !isSoldOut
              ? $(this)
                  .parents("li.product")
                  .find(".complementary-atc.add_to_cart")
                  .attr("disabled", "disabled")
              : $(this)
                  .parents("li.product")
                  .find(".complementary-atc.add_to_cart")
                  .removeAttr("disabled");
          }
        }
      );

    // sidebar cart checkout
     $(document).on("click", ".gk-sidebar-footer .cart-checkout-btn", (e) => {
        e.preventDefault();
        const link = $(".gk-sidebar-footer .cart-checkout-btn").attr('data-href');

        $.ajax({
          type: 'GET',
          url: `${theme.routes.cart_url}.js`,
          dataType: 'json', 
          success: function (data) { 
            if(data.items.length > 0) {
              window.dataLayer.push({ ecommerce: null })
              window.dataLayer.push({
                event: "begin_checkout",
                ecommerce: {
                  currency: "EUR",
                  value: data.total_price * 0.01 ?? 0,
                  items: 
                    data.items.map(p => { return { "item_id": (p.product_id).toString(), "item_name": p.product_title, "affiliation": p.vendor, "currency": "EUR", "discount": p.discounts, "item_category": p.product_type, "item_variant": p.variant_title, "price": p.price * 0.01, "quantity":  p.quantity }})
                }
              })
            }
            console.log(data); 
          },
          complete: function () { 
            console.log(link); 

            window.location.href = link ?? '/checkout';
          }
        });
      })

      $(document).on('click', '.gk-sidebar-you-may-link.mobile-view .close-upsell', function () {
        $(this).parents('.gk-sidebar-you-may-link').remove();
        sessionStorage.setItem('hideCartUpsell', true);
      });
      $(document).on('click', '.gk-sidebar-body__giftHeadingWrapper .close-gift-box', function () {
        $('#cart-gift-box').prop('checked', false).trigger('change');
      });
      $(document).ajaxComplete(function (event, xhr, settings) {
        if (settings?.url.includes('add.js') && xhr.status === 200) {
          // Call your function only when the request is successful
          sessionStorage.removeItem('hideCartUpsell');
        }
      });
});

$(document).on('change', '#cart-gift-box', function() {
  if ($(this).is(':checked')) {
    $('.gk-sidebar-body-gift-checkbox').addClass('hidden');
    $('.gk-sidebar-body-gift-boxes').removeClass('hidden');
  } else {
    $('.gk-sidebar-body-gift-checkbox').removeClass('hidden');
    $('.gk-sidebar-body-gift-boxes').addClass('hidden');
  }
  setTimeout(() => {
    getCartDrawerBottomHeight();
  }, 1000);
});

function getCartDrawerBottomHeight() {
  const sidebarBottom = document.querySelector('.gk-sidebar-custom-bottom');
  // Check if the element exists
  if (sidebarBottom) {
    // Get the element's height
    const height = sidebarBottom.offsetHeight;
    // Set it as a CSS variable in the root element
    document.documentElement.style.setProperty('--gk-sidebar-bottom-height', `${height}px`);
  }

  $.get("/browsing_context_suggestions.json", function(data) {
    let userCountry = data.detected_values.country.handle;
    $("html").attr("data-country", userCountry);
  });
}
getCartDrawerBottomHeight();
window.addEventListener('resize', getCartDrawerBottomHeight);

document.addEventListener('theme:cartchanged', function () {
  window.runExperiment1004155253 = 1;
});

$(document).ready(function () {
	$('li.item_with_festive_icon').mouseenter(function () {
		window._conv_q = window._conv_q || [];  
        _conv_q.push(["triggerConversion", "1004101953"]);
	});
	$('li.item_with_festive_icon').on('click', function () {
		window._conv_q = window._conv_q || [];  
        _conv_q.push(["triggerConversion", "1004101953"]);
	});
});